import { Component, Input } from '@angular/core';

@Component({
  selector: 'oren-landing-header',
  templateUrl: './landing-header.component.html',
  styleUrls: ['./landing-header.component.scss'],
})
export class LandingHeaderComponent {
  @Input() referenceType: string | null | undefined;
}
